export function isContext<T>(value: unknown, property: keyof T): value is T {
  return (
    typeof value === 'object' &&
    value !== null &&
    Object.prototype.hasOwnProperty.call(value, property)
  );
}
